import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { scenarioQueryKeys } from '../queryKeys'
import { resourcefulScenarioRequest } from '../requests'

export function useRiskProductsQuery({
  scenarioID,
  initialData,
  queryKey
}) {
  const queryClient = useQueryClient()
  // NOTE: We should contain a list of scenario resources
  // and reference riskProducts from there
  const riskProductRequests = resourcefulScenarioRequest(
    scenarioID, 'risk_products'
  )

  const riskProductsQuery = useQuery({
    queryFn: riskProductRequests.index,
    queryKey,
    initialData
  })

  const updateRiskProductMutation = useMutation({
    mutationFn: riskProductRequests.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).riskProducts] })
    },
  })

  const createRiskProductMutation = useMutation({
    mutationFn: riskProductRequests.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).riskProducts] })
    },
  })

  const deleteRiskProductMutation = useMutation({
    mutationFn: riskProductRequests.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).riskProducts] })
    },
  })

  const isFetching = riskProductsQuery.isFetching || updateRiskProductMutation.isLoading

  const isAnyLoading = riskProductsQuery.isFetching ||
    createRiskProductMutation.isLoading ||
    updateRiskProductMutation.isLoading ||
    deleteRiskProductMutation.isLoading

  return {
    data: riskProductsQuery.data,
    actions: {
      update: updateRiskProductMutation.mutateAsync,
      create: createRiskProductMutation.mutateAsync,
      delete: deleteRiskProductMutation.mutateAsync,
    },
    status: riskProductsQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
